import { Environment } from '@abp/ng.core';

const baseUrl = 'https://training-tracking-dev.upmuruguay.net';

const oAuthConfig = {
  issuer: 'https://training-tracking-backend-dev.upmuruguay.net/',
  redirectUri: baseUrl,
  clientId: 'TrainingTracking_App',
  responseType: 'code',
  scope: 'offline_access TrainingTracking',
  requireHttps: true,
};

export const environment = {
  name: 'development',
  production: false,
  useServiceWorker: true,
  application: {
    baseUrl,
    name: 'TrainingTracking',
  },
  oAuthConfig,
  impersonation: {
    tenantImpersonationEnabled: true,
    userImpersonationEnabled: true,
  },
  apis: {
    default: {
      url: 'https://training-tracking-backend-dev.upmuruguay.net',
      rootNamespace: 'Upm.TrainingTracking',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  appVersion: '0.0.1',
  grafana: {
    isEnabled: false,
    url: 'https://faro-collector-prod-sa-east-1.grafana.net/collect/089d85b5c235b586075ce82a9c4c1fd3',
  },
} as Environment;
